import { GameClient } from '../../gameClient/gameClient';
import { GameStartShortData } from '../../types/client';
import { getBrowserName } from '../../utils/browser';
import { CurrentUser } from '../../general/modules/user/currentUser';
import { getUserSuid } from '../../general/modules/getUserSuid';
import { SetStartShortDataCommand } from '../../gameClient/clientCommands/setStartShortDataCommand';
import { getEnrichedClusterConfig } from '../../general/cmdGetStartData';

export class GetStartShortDataHandler {
    public handle(): void {
        const shortStartData :GameStartShortData = {
            accountId: CurrentUser.getInstance().getAccountId(),
            accountToken: CurrentUser.getInstance().getAuthToken(),
            browser: getBrowserName(),
            clusterConfig: getEnrichedClusterConfig(),
            deviceId: window.app.deviceIdentifier,
            entryPoint: window.app.config.current_entry_point,
            locale: window.app.config.locale,
            restApiUrl: window.app.restApiUrl,
            sig: window.app.config.sig,
            suid: getUserSuid(),
            suidSimulate: window.app.config.suid_simulate

        };
        GameClient.getInstance().sendCommand<void>(new SetStartShortDataCommand(shortStartData));
    }
}
